import { Component } from "react";

interface IMeta {
    touched: boolean;
    error: string;
    warning: string;
}

interface IProps {
    input: any;
    placeholder?: string;
    type: string;
    meta: IMeta;
}

export default class TextArea extends Component<IProps> {
    render() {
        const { meta, type, placeholder } = this.props;

        return (
            <>
                <div>
                    <textarea {...this.props.input} className="form-control" placeholder={placeholder} />
                    {meta.touched &&
                        ((meta.error && <span className="error">{meta.error}</span>) ||
                            (meta.warning && <span className="warning">{meta.warning}</span>))}
                </div>
            </>
        );
    }
}
